<script setup lang="ts">
import type { FerryProductCardData, FerryUpsellType } from '../../../models';

import FerryProductCardContent from './FerryProductCardContent.vue';

interface FerryProductCardProps {
  productCardData: FerryProductCardData;
  printMode: boolean;
}

const props = defineProps<FerryProductCardProps>();

interface FerryProductCardEmits {
  (event: 'change-upsell', upsellType: FerryUpsellType): void;
  (event: 'show-details'): void;
}

const emit = defineEmits<FerryProductCardEmits>();
</script>

<template>
  <div
    class="ferry-product-card"
    :class="{
      'print-mode': props.printMode,
    }"
  >
    <FerryProductCardContent
      :product-card-content="props.productCardData"
      :print-mode="props.printMode"
      @change-upsell="emit('change-upsell', $event)"
      @show-details="emit('show-details')"
    />
  </div>
</template>

<style scoped lang="scss">
.ferry-product-card {
  background: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-12);
  overflow: hidden;
}
</style>
